var map = {
	"./about.svg": 7,
	"./add-user-1.svg": 8,
	"./add-user.svg": 9,
	"./back.svg": 10,
	"./bell.svg": 11,
	"./camera.svg": 12,
	"./cancel.svg": 13,
	"./chat.svg": 14,
	"./dislike-color-vector.svg": 15,
	"./dislike-color.svg": 16,
	"./dislike.svg": 17,
	"./dropdown.svg": 18,
	"./edit.svg": 19,
	"./envelope.svg": 20,
	"./library.svg": 21,
	"./like-color-vector.svg": 22,
	"./like-color.svg": 23,
	"./like.svg": 24,
	"./lock.svg": 25,
	"./microphone.svg": 26,
	"./more.svg": 27,
	"./padlock-alt.svg": 28,
	"./padlock.svg": 29,
	"./paperclip.svg": 30,
	"./play.svg": 31,
	"./recommendation.svg": 32,
	"./recording.svg": 33,
	"./return.svg": 34,
	"./ribbon.svg": 35,
	"./search.svg": 36,
	"./settings.svg": 37,
	"./smile.svg": 38,
	"./unlock.svg": 39,
	"./user.svg": 40,
	"./view.svg": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;